// Modül bayrağı → menü rota(lar)ı eşlemesi. Bir modül bayrağı KAPALI ise
// karşılık gelen rotalar menüden gizlenir (Layout tüketir).
export const MODULE_ROUTES = {
  "module.categories": ["/kategoriler"],
  "module.catalog_health": ["/katalog-sagligi"],
  "module.temp_price": ["/halk-gunu"],
  "module.stock_count": ["/sayim"],
  "module.approvals": ["/onaylar"],
  "module.purchasing": ["/satin-alma"],
  "module.goods_receipt": ["/mal-kabul"],
  "module.transfers": ["/transferler"],
  "module.suppliers": ["/tedarikciler"],
  "module.logistics": ["/lojistik"],
  "module.waste": ["/fire"],
  "module.accounting": ["/muhasebe"],
  "module.edocs": ["/e-belge"],
  "module.wholesale_audit": ["/toptan-denetim"],
  "module.scoring": ["/puan-odul"],
  "module.surveys": ["/anketler"],
  "module.market_research": ["/firsatlar"],
  "module.ai": ["/ai"],
};

// features objesinden gizlenecek rota kümesini hesaplar.
export function hiddenRoutesFromFeatures(features) {
  const hidden = new Set();
  if (!features) return hidden;
  for (const [flag, routes] of Object.entries(MODULE_ROUTES)) {
    if (features[flag] === false) routes.forEach((r) => hidden.add(r));
  }
  return hidden;
}
